(function(){
  if(window.__pblInfoInit)return; window.__pblInfoInit=1;
  function init(){
// Tabs (recipe)
  var tabs=[].slice.call(document.querySelectorAll('.pbl-tab'));
  function select(t){tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;document.getElementById(x.getAttribute('aria-controls')).hidden=!on;});}
  tabs.forEach(function(t,i){
    t.addEventListener('click',function(){select(t)});
    t.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){var n=tabs[(i+(e.key==='ArrowRight'?1:tabs.length-1))%tabs.length];select(n);n.focus();}});
  });
  // UGC video: click-to-play (no autoplay, no data cost until asked)
  document.querySelectorAll('.pbl-ugc__item[data-video] .pbl-play').forEach(function(b){
    b.addEventListener('click',function(){
      var fig=b.parentNode,v=document.createElement('video');
      v.src=fig.dataset.video;v.controls=true;v.playsInline=true;v.autoplay=true;v.poster=fig.querySelector('img').src;
      fig.innerHTML='';fig.appendChild(v);v.focus();
    });
  });
// Size finder -> variant deep link (data comes from the section's product pickers)
var money=function(cents){return '$'+(cents/100).toFixed(2)};
var isSub=function(v){return /subscri/i.test(v.o2||'')};
document.querySelectorAll('[data-pbl-finder]').forEach(function(f){
  var freqSet=f.querySelector('[data-pbl-freq]'),freqNa=f.querySelector('[data-pbl-freq-na]');
  var label=f.querySelector('[data-pbl-sum-label]'),price=f.querySelector('[data-pbl-sum-price]'),cta=f.querySelector('[data-pbl-cta]');
  var pick=function(input,wantSub){
    var vs;try{vs=JSON.parse(input.getAttribute('data-variants')||'[]')}catch(e){vs=[]}
    var sizeEl=f.querySelector('input[name="size"]:checked');
    var opt=sizeEl?sizeEl.getAttribute('data-option'):null;
    var match=vs.filter(function(v){return !opt||v.o1===opt});
    if(!match.length)match=vs.slice();
    var want=match.filter(function(v){return wantSub?isSub(v):!isSub(v)});
    return want[0]||match[0]||null;
  };
  var upd=function(){
    var bag=f.querySelector('input[name="bag"]:checked');if(!bag)return;
    var vs;try{vs=JSON.parse(bag.getAttribute('data-variants')||'[]')}catch(e){vs=[]}
    var canSub=vs.some(isSub);
    if(freqSet)freqSet.disabled=!canSub;
    if(freqNa)freqNa.hidden=canSub;
    var freqEl=f.querySelector('input[name="freq"]:checked');
    var wantSub=canSub&&freqEl&&freqEl.value==='sub';
    var v=pick(bag,wantSub);
    var sizeEl=f.querySelector('input[name="size"]:checked');
    var card=sizeEl?sizeEl.closest('.pbl-size__card'):null;
    var sizeName=card&&card.querySelector('b')?card.querySelector('b').textContent:'';
    if(label)label.textContent=[sizeName,bag.getAttribute('data-name'),wantSub?'every 30 days':''].filter(Boolean).join(' · ');
    if(price&&v){
      var once=pick(bag,false);
      price.innerHTML=(wantSub&&once&&once.price>v.price?'<s>'+money(once.price)+'</s>':'')+money(v.price);
    }
    if(cta&&v)cta.href=bag.getAttribute('data-url')+'?variant='+v.id;
    f.querySelectorAll('input[name="bag"]').forEach(function(i){
      var el=i.closest('.pbl-bag').querySelector('[data-bag-price]');if(!el)return;
      var pv=pick(i,wantSub)||pick(i,false);if(pv)el.textContent=money(pv.price);
    });
  };
  f.addEventListener('change',upd);upd();
});

  // Sticky bar: show after the hero, hide over the final CTA
  var bar=document.getElementById('pbl-sticky'),hero=document.querySelector('.pbl-hero'),fin=document.getElementById('pbl-final'),finder=document.querySelector('.pbl-finder__buy');
  if('IntersectionObserver' in window&&bar){
    var heroOut=false,finIn=false,finderIn=false;
    function upd(){var on=heroOut&&!finIn&&!finderIn;bar.classList.toggle('is-on',on);bar.setAttribute('aria-hidden',!on);bar.querySelectorAll('a').forEach(function(a){a.tabIndex=on?0:-1});}
    new IntersectionObserver(function(e){heroOut=!e[0].isIntersecting;upd()}).observe(hero);
    new IntersectionObserver(function(e){finIn=e[0].isIntersecting;upd()}).observe(fin);
    if(finder)new IntersectionObserver(function(e){finderIn=e[0].isIntersecting;upd()}).observe(finder);
  }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
